$(document).ready(function(){
  setTimeout(function(){
    let btn = $('.qvd_button_container button');
    if(btn[0]){
      btn.click(function(){
        btn.hide();
        pprocessQVDForm(btn);
      });
      setElements();
    }
  },1000);
});

function setElements(){
  let image = "https://cdn.shopify.com/s/files/1/0415/7816/8473/t/11/assets/ck-lifestyle-black-aw24.webp?v=1734788938";
  $('.qvd_video-container').html('<img src="'+image+'" class="qvd-popup-left-img" >');
  let flagHtml = '<img src="https://cdn.shopify.com/s/files/1/0415/7816/8473/t/11/assets/jamaica.png?v=1734965179">';
  $('.qvd_popup_input-wrapper .qvd_input_prefix').html(flagHtml);

  let qvd_header = $('.qvd_popup_content_first.svelte-h7w12q');
  let headet_html = '<div class="qvd_popup_header svelte-h7w12q">Feel Beautiful, Feel Confident! Get 10% Off Your First Order</div>';
  if (!qvd_header.find('.qvd_popup_header').length > 0) {
    qvd_header.prepend(headet_html);
    console.log('added content');
  }else{
    console.log(qvd_header.html());
  }
}

function validE(e) {
  const patt = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return patt.test(e);
}
function pprocessQVDForm(btn){
  let name, email, phone;
  let location = 'VIP List';
  let is_valid = '';
  let errors = [];
  $('.qvd_button_container .form-errors').remove();
   $('.qvd_popup_form input').each(function(index, element) {
     let placeholder = $(element).attr('placeholder');
     if (placeholder.includes('name')) {
        name = $(this).val();
       if(name.replace(' ','').length < 2){
         errors.push('Please fill the valid name!');
       }
     } else if (placeholder.includes('email')) {
        email = $(this).val();
       if (email.length > 0 && !validE(email)){
          errors.push('Please fill the valid Email Address!');
       }
       
     } else if (placeholder.includes('XXXX')) {
        phoneValue = $(this).val();
        phone = phoneValue.trim().replace(/[^0-9]/g, "");
       if (!/^\d{10}$|^1\d{10}$/.test(phoneValue)){
           errors.push('Invalid phone number. Please enter a valid 10-digit number (e.g., 8763773500).');
        }else{
           if (phone.length === 10) {
        	phone = "1" + phone;
             $(this).val(phone);
          }
        }
     }
  });
  if(errors.length > 0){
    let errorHtml = '<ul class="form-errors">';
    for(let i=0; i< errors.length; i++){
      errorHtml += '<li class="errors">'+errors[i]+'</li>';
    }
    errorHtml += '</ul>';
    $('.qvd_button_container').append(errorHtml);
    btn.show();
    return false;
  }
  const makeContactPayload = {
	token: "oJ3bWXOMePBoAr6S2MBiaT1d2t5RRFe8DC8sJ3V7b5e121be",
	phone: phone,
	name: name,
	groups: location,
	custom: {
	  email: email,
	  location: location,
	},
  };

  makeContact(makeContactPayload);
}

function makeContact(payload) {
  console.log(payload);
  $.ajax({
    url: "https://wa.paperlessblueprint.com/api/wpbox/makeContact",
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(payload),  
    success: function(response) {
      console.log(response);
      $('.qvd_form-container').html('<p class="qvd-contact-success">Thank you for submitting your details. We are processing them and will respond shortly.</p>');
    },
    error: function(error) {
      console.log(error);
    }
  });
}

